export default __webpack_public_path__ + "static/media/Large-Bread-5.be52a75d.jpg";